import React from 'react';

const getCategoryImage = (catId) => {
    const basePath = '/img/application/';
    switch (catId) {
        case 'droitAerien': return `${basePath}droitAerien.png`;
        case 'meteo': return `${basePath}meteo.png`;
        case 'navigation': return `${basePath}navigation.png`;
        case 'connaissance': return `${basePath}connaissance.png`;
        case 'complet': return `${basePath}complet.png`;
        default: return `${basePath}complet.png`;
    }
};

const CategoryButton = ({
    category,
    isSelected,
    onClick,
    language = 'fr',
    progress,
    time,
}) => {
    const hasStats = progress != null && progress > 0;
    const displayTime = time && time !== '0h 0m' ? time : null;

    return (
        <button
            onClick={() => onClick(category.id)}
            className={`relative group flex flex-col items-center justify-center gap-3 md:gap-4 p-4 md:p-6 rounded-2xl md:rounded-3xl transition-all duration-300 border w-full h-full
                ${isSelected
                    ? 'bg-white dark:bg-[#121212] border-blue-400 dark:border-blue-400/60 shadow-[0_0_15px_rgba(59,130,246,0.3)] dark:shadow-[0_0_20px_rgba(59,130,246,0.25)] ring-1 ring-blue-300/50 dark:ring-blue-400/30'
                    : 'bg-white dark:bg-[#121212] border-gray-200 dark:border-white/5 hover:border-gray-300 dark:hover:border-white/10 hover:bg-gray-50 dark:hover:bg-[#1a1a1a]'
                }`}
        >
            {/* Icon Container - Size unified to 10x10 */}
            <div className="w-10 h-10 flex items-center justify-center opacity-80 group-hover:opacity-100 transition-opacity">
                    <img
                        src={getCategoryImage(category.id)}
                        alt={category.label[language]}
                        className={`w-full h-full object-contain transition-all
                            ${isSelected
                                ? 'brightness-100 dark:brightness-110 grayscale-0'
                                : 'brightness-[0.4] dark:brightness-50 grayscale-[0.5] group-hover:brightness-[0.7] dark:group-hover:brightness-90 group-hover:grayscale-0'
                            }`}
                    />
            </div>

            {/* Label */}
            <span className={`text-[10px] font-black text-center uppercase tracking-widest transition-colors leading-tight whitespace-nowrap
                ${isSelected
                    ? 'text-blue-600 dark:text-blue-400'
                    : 'text-gray-600 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-gray-200'
                }`}
            >
                {category.label[language]}
            </span>

            {/* Progress bar + time (desktop only) */}
            {hasStats && (
                <div className="hidden md:flex flex-col items-center gap-1 w-full px-1">
                    <div className="w-full h-1 rounded-full overflow-hidden bg-gray-200 dark:bg-white/10">
                        <div
                            className={`h-full rounded-full transition-all duration-500 ${
                                progress === 100
                                        ? 'bg-green-500'
                                        : progress >= 50
                                            ? 'bg-yellow-500'
                                            : 'bg-blue-500'
                            }`}
                            style={{ width: `${progress}%` }}
                        />
                    </div>
                    <div className="flex items-center gap-1">
                        <span className={`text-[8px] font-bold ${isSelected ? 'text-blue-500 dark:text-blue-400' : 'text-gray-400 dark:text-gray-500'}`}>
                            {progress}%
                        </span>
                        {displayTime && (
                            <>
                                <span className="text-[8px] text-gray-300 dark:text-gray-600">&middot;</span>
                                <span className={`text-[8px] font-medium ${isSelected ? 'text-blue-500 dark:text-blue-400' : 'text-gray-400 dark:text-gray-500'}`}>
                                    {displayTime}
                                </span>
                            </>
                        )}
                    </div>
                </div>
            )}
        </button>
    );
};

export default CategoryButton;
